import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  AUTH_LOAD_START,
  AUTH_LOAD_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  AUTH_UPDATE,
  USER_UPDATED,
  AUTH_UPDATE_FAIL
} from '../actions/types';
import {clearUserSettings} from "../components/Atoms/client";
import {
  AUTH_STATUS,
  clearAuthorization,
  getAuthorization,
  permissionsMapFromCapabilities
} from "../utils/capabilityAccess";

const emptyAuthz = () => ({
  systemRole: '',
  orgRoleId: null,
  orgRoleName: null,
  capabilities: []
});

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: null,
  loading: true,
  authStatus: localStorage.getItem('token') ? AUTH_STATUS.LOADING : AUTH_STATUS.LOADED,
  user: null,
  roles: [],
  error: '',
  authorization: getAuthorization(),
  userPermissions: {
    permissions: {},
    roleName: ''
  }
};

export default function auth(state = initialState, action) {
  const { type, payload } = action,
    hasToken = localStorage.getItem('token');

  switch(type) {
    case AUTH_LOAD_START:
      return {
        ...state,
        loading: true,
        authStatus: AUTH_STATUS.LOADING,
        error: ''
      };
    case AUTH_LOAD_ERROR:
      return {
        ...state,
        loading: false,
        authStatus: AUTH_STATUS.ERROR,
        error: payload || 'Failed to load user',
        isAuthenticated: !!hasToken
      };
    case USER_LOADED: {
      const incoming = payload?.authorization;
      const stateCaps = state.authorization?.capabilities;
      const incomingCaps = incoming?.capabilities;
      // Defend against cached empty /api/auth clobbering a good login payload.
      const keepLoginAuth =
        Array.isArray(stateCaps) &&
        stateCaps.length > 0 &&
        state.authorization?.orgRoleId &&
        incoming &&
        Array.isArray(incomingCaps) &&
        incomingCaps.length === 0 &&
        !incoming.orgRoleId;
      const authorization = keepLoginAuth
        ? state.authorization
        : (incoming || state.authorization);
      const permissions = permissionsMapFromCapabilities(
        authorization?.capabilities
      );
      return {
        ...state,
        isAuthenticated: !!hasToken,
        loading: false,
        authStatus: AUTH_STATUS.LOADED,
        error: '',
        user: payload.user,
        roles: payload.roles,
        authorization,
        userPermissions: {
          permissions,
          roleName: authorization?.orgRoleName || ''
        }
      };
    }
    case REGISTER_SUCCESS:
    case LOGIN_SUCCESS: {
      localStorage.setItem('token', payload.token);
      const authorization = payload.authorization || state.authorization;
      return {
        ...state,
        ...payload,
        isAuthenticated: !!hasToken ?? true,
        loading: true,
        authStatus: AUTH_STATUS.LOADING,
        authorization,
        userPermissions: {
          permissions: permissionsMapFromCapabilities(authorization?.capabilities),
          roleName: authorization?.orgRoleName || ''
        }
      };
    }
    case REGISTER_FAIL:
    case AUTH_UPDATE:
      return {
        ...state,
        loading: true,
      };
    case USER_UPDATED:
      const updatedUser = payload;
      if (updatedUser.password)
        delete updatedUser.password
      return {
        ...state,
        loading: false,
        user: { ...state.user, ...updatedUser }
      };
    case AUTH_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem('token');
      clearUserSettings();
      clearAuthorization();
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        authStatus: AUTH_STATUS.LOADED,
        user: null,
        error: '',
        authorization: emptyAuthz(),
        userPermissions: { permissions: {}, roleName: '' }
      };
      default:
        return state;
  }
}
